<template>
  <modal
    ref="apiTrigger"
    name="api-trigger"
    ok-title="Stiahnuť"
    cancel-title="Zrušiť"
    title="Stiahnuť intervalové dáta"
    @hidden="Object.assign($data, $options.data())"
    @ok="download"
  >
    <h4>{{ energetic }}</h4>
    <b-form-group label="Obdobie" label-cols-sm="5" label-for="date">
      <single-date-picker
        :value="date"
        maximum-view="month"
        minimum-view="month"
        format="MMMM yyyy"
        :disabled-dates="{ from: $moment().startOf('month').toDate() }"
        @input="(val) => (date = val)"
      />
    </b-form-group>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDatePicker from '@/components/inputs/SingleDatePicker'
import moment from 'moment'

export default {
  components: {
    Modal,
    SingleDatePicker,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      energetic: '',
      date: moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD'),
    }
  },
  methods: {
    download() {
      this.$api
        .get('energy_data/trigger_portal/' + this.id, {
          params: { date: this.date },
        })
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: res.data.success,
            timer: 5000,
          })
        })
    },
  },
}
</script>
